export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) {
    return null
  }

  try {
    const registration = await navigator.serviceWorker.register("/sw.js")

    registration.addEventListener("updatefound", () => {
      const installing = registration.installing
      if (!installing) {
        return
      }

      installing.addEventListener("statechange", () => {
        if (installing.state === "installed" && navigator.serviceWorker.controller) {
          registration.waiting?.postMessage({ type: "SKIP_WAITING" })
        }
      })
    })

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      window.location.reload()
    })

    window.setInterval(() => {
      void registration.update()
    }, 60_000)

    return registration
  } catch (error) {
    console.error("Falha ao registrar service worker", error)
    return null
  }
}
